import { makeStyles } from "@material-ui/core";
import { colors } from "../../shared/utils/colors";

const useStyles = makeStyles({
  panel: {
    padding: "24px",
    borderRadius: 16,
    display: "flex",
    flexDirection: "column",
    gap: 16,
    border: "1px solid #d9d9d9",
    flex: 1,
  },
  field: { flex: 1 },
  label: { fontSize: 12, color: colors.greyFont },
  value: { color: colors.blueDarken },
  acciones: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 12,
    width: "100%",
  },
  accionesFinales: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 12,
    width: "100%",
    marginTop: "auto",
  },
  info: {
    width: "100%",
    boxSizing: "border-box",
    overflow: "hidden",
    "& .MuiAlert-message": {
      minWidth: 0,
      overflowWrap: "anywhere",
    },
  },
  accionBoton: {
    padding: "6px 24px",
    minWidth: 0,
    whiteSpace: "nowrap",
  },
  button: {
    color: colors.white,
    background: colors.blueDarken,
    borderRadius: 19,
    textTransform: "none",
    "&:hover": { background: colors.blueDarken },
    "& strong": { textTransform: "uppercase" },
  },
  archivoCargado: {
    display: "flex",
    flexDirection: "column",
    gap: 8,
    padding: "12px 16px",
    border: `1px solid ${colors.greyFont}`,
    borderRadius: 8,
  },
  archivoFila: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 16,
    "& .MuiTypography-root": {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      flex: 1,
      minWidth: 0,
    },
  },
  botonCotizar: {
    flexShrink: 0,
    padding: "4px 20px",
  },
  cancelar: {
    color: colors.blueDarken,
    alignSelf: "flex-start",
    marginTop: "auto",
  },
});

export default useStyles;
